import { Grid, withStyles } from '@material-ui/core';
import StopData from './StopData';
import StopImages from './StopImages';
import StopLocationMap from './StopLocationMap';
import { getStopDataByRouteMaxUIStopIndex } from '../Utils';

const styles = (theme) => ({
  headerText: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    fontWeight: 500,
    marginBottom: 10
  },
  fullHeight: { height: '100%', margin: 0 },
  viewContainer: {
    height: '100%',
    display: 'block'
  },
  errorContainer: {
    fontSize: theme.textFontSize,
    color: theme.gridOverlayFontColor,
    marginTop: '32%',
    border: `2px solid ${theme.gridOverlayFontColor}`,
    background: theme.gridOverlayBGColor,
    padding: '12px',
    width: 'max-content',
    fontWeight: 500,
    marginLeft: "10%"
  }
});

const StopDetails = ({
  route,
  stops,
  selectedStopIndex,
  glEventHub,
  classes,
  searchInputValue
}) => {
  const stopData = getStopDataByRouteMaxUIStopIndex(stops, selectedStopIndex);
  return stopData ? (
    <Grid container spacing={24} className={classes.fullHeight}>
      <Grid item xs={5} className={classes.viewContainer}>
        <div className={classes.headerText}>STOP DETAILS</div>
        <StopData stopData={stopData} route={route} searchInputValue={searchInputValue} />
        <StopLocationMap stopData={stopData} glEventHub={glEventHub} driverData={route} />
      </Grid>
      <Grid item xs={7} className={classes.fullHeight}>
        <StopImages stopData={stopData} route={route} />
      </Grid>
    </Grid>
  ) : (
    <div className={classes.errorContainer}>No stops available</div>
  );
};

export default withStyles(styles)(StopDetails);
